module.exports = __webpack_public_path__ + "static/media/36-11.a035a72b.mp3";